import { env } from '../../../../../common/util'

const MEETING_SCORE_PRESET_MAP: { [key: string]: string } = {
  dev: '67vfcqzsnrhae5ms',
  staging: '8y8hh3770b4v56e5',
  prod: '5mrw6z1nnl7jbszb',
}

export const MEETING_SCORE_PRESET_PRESET_ID = MEETING_SCORE_PRESET_MAP[env]

export interface WorkflowValues {
  nextSteps: boolean
  lifeEvents: boolean
  followUpTasks: boolean
  meetingAgenda: boolean
  coreMotivators: boolean
  decisionsAgreed: boolean
  decisionsNotAgreed: boolean
}

export interface EngagementValues {
  sentiment: boolean | null
  avgTalkTime: boolean
  questionRate: boolean
  avoidedLongMonologue: boolean
  clientQuestions: boolean
  clientConnection: boolean
  personalEngagement: boolean
  interactiveConversation: boolean
}

export interface SchedulingValues {
  calendarEvent: boolean
  futureMeetings: boolean
  overUnderTime: boolean | null
}

export interface ScoreResult {
  Workflow: StructuredCategory<WorkflowValues>
  Engagement: StructuredCategory<EngagementValues>
  Scheduling: StructuredCategory<SchedulingValues>
}

export interface StructuredCategory<T> {
  values: T
  improve: string[]
  strength: string[]
}
